import { InlineLoading, InlineNotification } from '@carbon/react';
import { useAtomValue } from 'jotai';
import { createResourceAtom } from 'lib/atoms';
import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import { DcaScenarioResponse } from 'types/dca-scenarios-api/responses';
import { DcaScenarioForm } from '../dca-scenario-form/dca-scenario-form';

export const EditDcaScenarioPage = () => {
  const { pathname } = useLocation();

  const resourceAtom = useMemo(
    () => createResourceAtom<DcaScenarioResponse>(pathname),
    [pathname]
  );
  const resource = useAtomValue(resourceAtom);

  if (resource.loading) return <InlineLoading />;

  if (resource.data && 'error' in resource.data)
    return (
      <InlineNotification
        kind="error"
        title={resource.data.error}
        lowContrast
      />
    );

  if (!resource.data)
    return (
      <InlineNotification
        kind="error"
        title="Something went wrong"
        lowContrast
      />
    );

  return (
    <DcaScenarioForm
      initialValues={{
        notes: resource.data.notes,
        name: resource.data.name,
        timeFormat: resource.data.timeFormat,
        qiFormat: resource.data.qiFormat,
        diFormat: resource.data.diFormat,
        durationOption: resource.data.durationOption,
        durationFormat: resource.data.durationFormat,
        durationPeriod: resource.data.durationPeriod,
        createdBy: resource.data.createdBy,
      }}
      scenarioName={resource.data.name}
      pageHref={resource.data.href}
      commentsUrl={resource.data.resources.comments.href}
      eventsUrl={resource.data.resources.events.href}
      areaConfigsUrl={resource.data.resources.areaConfigs.href}
    />
  );
};
